export default {
  api_r_user_module_documentManager_getModuleData: {
    path: 'm/document-manager/get-module-data/',
  },
  api_r_user_module_documentManager_getPermissions: {
    path: 'm/document-manager/get-permissions/',
  },
  api_r_user_module_documentManager_item_list: {
    path: 'm/document-manager/item/list/',
  },
  api_r_user_module_documentManager_item_level: {
    path: 'm/document-manager/item/level/',
  },
  api_r_user_module_documentManager_item_generateFilterHexCode: {
    path: 'm/document-manager/item/generate-filter-hex-code/',
  },
  api_r_user_module_documentManager_item_getFilters: {
    path: 'm/document-manager/item/get-filters/',
  },
  api_r_user_module_documentManager_item_folder_add: {
    path: 'm/document-manager/item/folder/add/',
  },
  api_r_user_module_documentManager_item_folder_edit: {
    path: 'm/document-manager/item/folder/edit/',
  },
  api_r_user_module_documentManager_item_folder_delete: {
    path: 'm/document-manager/item/folder/delete/',
  },
  api_r_user_module_documentManager_item_publication_add: {
    path: 'm/document-manager/item/publication/add/',
  },
  api_r_user_module_documentManager_item_publication_edit: {
    path: 'm/document-manager/item/publication/edit/',
  },
  api_r_user_module_documentManager_item_publication_delete: {
    path: 'm/document-manager/item/publication/delete/',
  },
  api_r_user_module_documentManager_item_publication_download: {
    path: 'm/document-manager/item/publication/download/',
  },
  api_r_user_module_documentManager_tag_select: {
    path: 'm/document-manager/tag/select/',
  },
  api_r_user_module_documentManager_pendingItem_list: {
    path: 'm/document-manager/pending-item/list/',
  },
  api_r_user_module_documentManager_pendingItem_validation: {
    path: 'm/document-manager/pending-item/validation/',
  },
  api_r_user_module_documentManager_userGuide_download: {
    path: 'm/document-manager/user-guide/download/',
  },
};
